import React from 'react'
import { Menu } from 'semantic-ui-react'
import { Stack, Box } from "@mui/material"
import {useLocation, useNavigate} from "react-router-dom";
import "./side-menu.scss"

export const SideMenu = ({
  items,
  vertical=true,
  action,
  style={},
  className="",
  activeItem="",
  handleItemClick
}) => {
  const location = useLocation()
  const navigate = useNavigate()
  activeItem = activeItem || String(location.hash).replace("#/", "")
  handleItemClick = handleItemClick || function (key) {
    const hash = `#/${key}`
    navigate(location.pathname + hash)
  }

  return (
    <Menu text vertical={vertical} className={`side-menu ${className}`} style={style}>
      {
        vertical && action
      }
      {
        items?.map((item, index) => (
          <Menu.Item
            key={`side-menu-item-${index}`}
            className={item.className || ''}
            content={item.label || item.key}
            active={activeItem === item.key}
            onClick={()=>handleItemClick(item.key)}
          />
        ))
      }
      {
        !vertical && action
      }
    </Menu>
  )
}

export default function SideMenuContainer ({ items, children, action, className = "", menuClassName = "" }) {
  return (
    <Stack direction="row" spacing={1} sx={{ width: '100%' }} className={className}>
      <Box className={menuClassName} sx={{ flexShrink: 0 }}>
        <SideMenu items={items} action={action}/>
      </Box>
      <Box sx={{flexGrow: 1, minWidth: 0, width: '100%'}}>
        {children}
      </Box>
    </Stack>
  )
}
